// extracted by mini-css-extract-plugin
export default {"FAQDescription":"faqAssembly_FAQDescription__Lz7KK"};